// Hard reload so react-query, zustand, SSE, WebSocket and the support widget
// all reset — surgical invalidation risks silent cache leakage between workspaces.
export const switchWorkspace = (workspaceId: string, destination?: string) => {
  localStorage.setItem("workspace_id", workspaceId);
  window.location.assign(destination ?? "/");
};
